import constants from 'core/types'
import { takeLatest, takeEvery, put, select, call } from 'redux-saga/effects'
import { setInLocalStorage } from 'core/libs/lib-storage-helpers'
import { accountHasLoaded } from 'core/libs/lib-wallet-helpers'
import { getBlocknativeSDK } from 'core/libs/lib-blocknative-helpers'

export function* walletSelect() {
  const { onboard } = yield select(state => state.wallet)
  const selected = yield onboard.walletSelect()
  if (selected) {
    const ok = yield onboard.walletCheck()
    if (!ok) {
      yield put({
        type: constants.SET_PROVIDER_AND_SDKS_ERROR,
        payload: {
          error: 'Wallet check did not pass'
        }
      })
    }
  }
}

export function* resetWallet() {
  const { onboard, walletProvider } = yield select(state => state.wallet)
  const { account } = walletProvider
  const blocknative = getBlocknativeSDK()

  if (accountHasLoaded(walletProvider)) {
    account.destroy()
  }

  yield onboard.walletReset()
  setInLocalStorage('selectedWallet', null)

  /* Unsubscribe from transaction events */
  blocknative.unsubscribe(account.address)

  yield put({
    type: constants.RESET_WALLET
  })
}

export function* watchWalletActions() {
  yield takeEvery(constants.WALLET_SELECT, walletSelect),
  yield takeEvery(constants.INIT_RESET_WALLET, resetWallet)
}

